<template>
  <div class="row progetti">
   <div class="progetto col col-s12 m6" style="" v-for="(item, index) in filtrati" v-on:remove="onRemove(index)">
        <router-link v-if="item.link=='1'" :to="'/inside/progetto/p'+item.id"><img :src="'/site/images/p/'+item.id+'.jpg'" /></router-link>
        <img v-if="item.link!='1'" :src="'/site/images/p/'+item.id+'.jpg'" />

        <el-tooltip :content="item.stato" placement="top" style="float:right;" v-if="item.stato!=''">
          <i class="material-icons">menu</i>
        </el-tooltip>
        
        <div class="titolo">{{item.titolo}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news',
  props: {
    titolo: '',
    link: '',
    image: ''
  },
  computed:{
    filtrati: function () {
      //if(this.termine=='')
        //return $teras.progetti
      var itemsFilter = []
      for (let item of this.$teras.progetti)
        if(item.tipologia.toLowerCase().indexOf(this.$route.params.id.toLowerCase()) > -1)
          itemsFilter.push(item)
      return itemsFilter
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img{
  width: 100%;
  padding:0;
  display:block;
  max-height:342px;
  overflow:hidden;
}.titolo{
  height:50px;
  text-transform:uppercase;
  font-size:1.4rem;
  line-height:20px;
  padding:5px 0;
  color: #222222;
}@media only screen and (min-width: 901px){

  div.progetto:nth-child(odd) {
    padding-right:25px;
    padding-left:0;
  }div.progetto:nth-child(even) {
    padding-right:0;
    padding-left:25px;
  }

}
</style>



// WEBPACK FOOTER //
// Tipologia.vue?fb07505e